import { useParams } from "react-router-dom";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { toast } from "sonner";
import { InterfaceModelContent } from "@/components/interface/InterfaceModelContent";
import { Card } from "@/components/ui/card";
import { useInterfaceModel } from "@/hooks/useInterfaceModel";

const BusinessInterface = () => {
  const { businessTypeId } = useParams();
  const { data: interfaceModel, isLoading, error } = useInterfaceModel(businessTypeId);

  // Initialiser avec un tableau vide au lieu des données de démonstration
  const sampleData = [];

  if (isLoading) {
    return (
      <DashboardLayout userType="owner">
        <div>Chargement...</div>
      </DashboardLayout>
    );
  }

  if (error) {
    console.error("Erreur lors du chargement de l'interface:", error);
    return (
      <DashboardLayout userType="owner">
        <Card className="p-6">
          <p className="text-red-500">Une erreur est survenue lors du chargement de l'interface</p>
        </Card>
      </DashboardLayout>
    );
  }

  if (!interfaceModel) {
    console.log("Aucun modèle d'interface trouvé");
    return (
      <DashboardLayout userType="owner">
        <Card className="p-6">
          <p className="text-amber-500">Configuration de l'interface en cours...</p>
          <p className="mt-2 text-sm text-gray-600">
            Veuillez contacter l'administrateur si ce message persiste.
          </p>
        </Card>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout userType="owner">
      <InterfaceModelContent
        interfaceModel={interfaceModel}
        sampleData={sampleData}
        onSaleClick={() => {
          console.log("Sale clicked");
          toast.success("Vente enregistrée");
        }}
        onRestock={() => {
          console.log("Restock clicked");
          toast.success("Stock mis à jour");
        }}
        onLoss={() => {
          console.log("Loss clicked");
          toast.success("Perte enregistrée");
        }}
        onDelete={() => {
          console.log("Delete clicked");
          toast.success("Produit supprimé");
        }}
        onReturn={() => {
          console.log("Return clicked");
          toast.success("Retour enregistré");
        }}
      />
    </DashboardLayout>
  );
};

export default BusinessInterface;